import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconNote1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.75C3 4.23122 4.23122 3 5.75 3H18.25C19.7688 3 21 4.23122 21 5.75V14.5H17.25C15.7312 14.5 14.5 15.7312 14.5 17.25V21H5.75C4.23122 21 3 19.7688 3 18.25V5.75Z" fill="currentColor"/><Path d="M16 20.8723C16.4172 20.7404 16.801 20.5097 17.1161 20.1945L20.1945 17.1161C20.5097 16.801 20.7404 16.4172 20.8723 16H17.25C16.5596 16 16 16.5596 16 17.25V20.8723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote1;
